import script from "./CardComponent.vue?vue&type=script&lang=ts&setup=true&async=true"
export * from "./CardComponent.vue?vue&type=script&lang=ts&setup=true&async=true"

import "./CardComponent.vue?vue&type=style&index=0&id=184c0365&lang=scss"

const __exports__ = script;

export default __exports__